import { Component, Inject, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { formatDate } from "@angular/common";
import { OtpVerifyComponent } from "src/app/shared-modules/otp-verify/otp-verify.component";
import { TruckOwnerService } from "../truck-owner.service";
import { MatSelect } from "@angular/material/select";
import { AbstractControl, ValidationErrors } from '@angular/forms';

function emailValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) return null; // Only validate if field has value
  const atIndex = value.indexOf('@');
  const dotIndex = value.lastIndexOf('.');
  if (atIndex > 0 && dotIndex > atIndex + 1 && dotIndex < value.length - 1) {
    return null;
  }
  return { invalidEmail: true };
}

@Component({
  selector: "app-driver-add",
  templateUrl: "./driver-add.component.html",
  styleUrls: ["./driver-add.component.css"],
})
export class DriverAddComponent implements OnInit {
  profileForm!: FormGroup;
  contactForm!: FormGroup;
  documentForm!: FormGroup;
  public invalidInsuranceDate: boolean = false;
  public invalidlicenseDate: boolean = false;
  public invalidDocLicense: boolean = false;
  public invalidDob: boolean = false;
  today = new Date();
  file: any;
  token: any;
  truckList: any = [];
  loading: boolean = false;
  id: any;
  @Input() min: any;
  minDate = new Date();
  public mobileVerified = 0;
  public emailVerified = 0;
  public licenseImageName: string;
  public insuranceImageName: string;
  drivingLicence: any;
  insurance: any;
  languageId: any;
  truckDropDownDispaly: boolean = true;
  reasons: boolean = false;
  status: boolean = false;
  emailregex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  remarksArray: any = [];
  driverType: any = "-1";
  driverNumber: any = -1;
  minDob = new Date();
  DrivingLicence: any;
  insuranceLicence: any;
  imgLoading: boolean = false;
  ismobileVerified: boolean = false;
  drivingLicenceLoading: boolean = false;
  insuranceLoading: boolean = false;
  isDlVerifying: boolean = false;
  isDlVerified: boolean = false;
  dlVerificationData: any = null;
  hasTransportAuthorization: boolean = false;
  autoPopulatedFields: { [key: string]: boolean } = {};
  @ViewChild("langSelect") langSelect: MatSelect;

  constructor(
    private matdialogre: MatDialogRef<DriverAddComponent>,
    private matDialog: MatDialog,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: TruckOwnerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.driverGet();
    this.profileForm = this.formBuilder.group({
      username: ["", Validators.required],
      mobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[1-9][0-9]{9}$")
        ]),
      ],
      email: ['', emailValidator],
      dob: [""],
      gender: [""],
      driving_license_number: [
        "",
        Validators.compose([Validators.pattern("^[A-Z0-9 -]{10,20}$")]),
      ],
      license_expiry_date: [""],
      truck_name: [""],
      truck_id: [""],
      emergency_contact: ["", Validators.pattern("^[1-9][0-9]{9}$")],
      profile_image: [""],
      driver_status: [""],
      driver_remarks: [""],
      known_lang: [""],
    });

    this.contactForm = this.formBuilder.group({
      name: ["", Validators.compose([Validators.pattern("^[a-zA-Z0-9\\s]+$")])],
      email: ['', emailValidator],
      address_line: [""],
      area: [""],
      city: [""],
      state: [""],
      pincode: ["",Validators.pattern("^[0-9]{6}$")],
      mobile: ["", Validators.pattern("^[1-9][0-9]{9}$")],
      gst: [""],
    });

    this.documentForm = this.formBuilder.group({
      driving_license: [""],
      driving_license_expiry: [""],
      insurance: [""],
      insurance_expiry: [""],
    });

    if (this.data) {
      this.profileForm.patchValue(this.data);
      this.profileForm.controls["mobile"].disable();
      this.contactForm.patchValue(this.data.contact_details);
      this.documentForm.patchValue(this.data.documents);
      this.mobileVerified = this.data.loginInfo[0].mobile_verified;
      this.emailVerified = this.data.loginInfo[0].email_verified;
      if (
        this.data.is_dl_verified === true ||
        this.data.is_dl_verified === 1 ||
        this.data.dl_verified === true ||
        this.data.dl_verified === 1 ||
        this.data.documents?.is_dl_verified === true ||
        this.data.documents?.is_dl_verified === 1 ||
        this.data.documents?.dl_verified === true ||
        this.data.documents?.dl_verified === 1
      ) {
        this.isDlVerified = true;
        this.autoPopulatedFields['driving_license_number'] = true;
        this.autoPopulatedFields['dob'] = true;
        if (this.data.username) this.autoPopulatedFields['username'] = true;
        if (this.data.gender) {
          this.autoPopulatedFields['gender'] = true;
          this.profileForm.controls['gender'].disable();
        }
        if (this.data.license_expiry_date || this.data.documents?.driving_license_expiry) {
          this.autoPopulatedFields['driving_license_expiry'] = true;
          this.autoPopulatedFields['license_expiry_date'] = true;
        }
      }
      this.truckDropDownDispaly = false;
      this.status = true;
      this.reasons = true;
      if (this.data.driver_remarks == "") {
        this.reasons = false;
      }
      if (this.data?.truckInfo[0]) {
        this.profileForm.patchValue({
          truck_name: this.data?.truckInfo[0]?.truck_number,
        });
        this.profileForm.patchValue({ truck_id: this.data?.truckInfo[0]?._id });
      } else {
        this.profileForm.patchValue({ truck_name: "" });
        this.profileForm.patchValue({ truck_id: "" });
      }
      this.viewImages();
    }

    this.getTrucks();
    var year = this.minDob.getFullYear() - 18;
    let returnData = this.formatFormDate(new Date(`12/31/${year}`));
    this.minDob = new Date(returnData);
    this.getlanguage();
  }

  driverGet() {
    this.services
      .getDriverList(this.token, this.driverType, this.driverNumber)
      .subscribe((response: any) => {});
  }

  public getTrucks() {
    this.services.GetAvailableTrucks(this.token).subscribe((response: any) => {
      if (response.status === 200) {
        this.truckList = response.body.data;
      }
    });
  }

  viewImages() {
    this.DrivingLicence = decodeURI(
      this.data?.documents?.driving_license
        .split("/")
        .slice(-1)
        .pop()
        .split("-")
        .slice(-1)
        .pop()
    );

    this.insuranceLicence = this.data?.documents?.insurance
      .split("/")
      .slice(-1)
      .pop()
      .split("-")
      .slice(-1)
      .pop();
  }

  public get ProfileFormControl() {
    return this.profileForm.controls;
  }

  public get contactFormControl() {
    return this.contactForm.controls;
  }

  public get documentFormControl() {
    return this.documentForm.controls;
  }

  public onDateChnage(num: number) {
    if (num === 1 && this.profileForm.value.license_expiry_date < this.today) {
      this.invalidlicenseDate = true;
    } else if (num === 2 && this.profileForm.value.dob > this.today) {
      this.invalidDob = true;
    } else if (
      num === 3 &&
      this.documentForm.value.driving_license_expiry < this.today
    ) {
      this.invalidDocLicense = true;
    } else if (
      num === 4 &&
      this.documentForm.value.insurance_expiry < this.today
    ) {
      this.invalidInsuranceDate = true;
    } else {
      this.invalidDob = false;
      this.invalidDocLicense = false;
      this.invalidInsuranceDate = false;
      this.invalidlicenseDate = false;
    }
  }
  public TruckAssigneClicked() {
    this.truckDropDownDispaly = true;
  }

  public mobileVerification(): void {
    if (!this.profileForm.controls["mobile"].valid) {
      this.profileForm.controls["mobile"].markAsTouched();
      return;
    }
    const dataValue = {
      email: this.profileForm.value.mobile,
      displayText: "Mobile Number",
      from: "truckowner",
      user_type: "driver",
    };
    let matDialogref = this.matDialog.open(OtpVerifyComponent, {
      width: "500px",
      data: {
        dataKey: dataValue,
      },
      // autoFocus: false,
    });
    matDialogref.afterClosed().subscribe((res: any) => {
      if (res.event === "Success") {
        this.mobileVerified = 1;
        this.ismobileVerified = true;
      }
    });
  }
  public getlanguage() {
    this.services.GetLanguageID().subscribe((response: any) => {
      this.languageId = response.data;
    });
  }
  onChange(event: any): void {
    this.file = event.target.files[0];
    this.imgLoading = true;
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (this.file && !allowedTypes.includes(this.file.type)) {
      this.imgLoading = false;
      this.snackBar.open("Invalid file format. Upload JPG, JPEG, or PNG.", "Close", {
        duration: 4000,
      });
      return;
    }
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status === 201) {
          this.imgLoading = false;
          this.profileForm.controls["profile_image"].setValue(response.body.image_link);
          this.file = null;
          this.snackBar.open("Image uploaded successfully!", "OK", {
            duration: 4000,
          });
        }
      },
      (error) => {
        this.imgLoading = false;
        this.snackBar.open(error.error.message || "Image upload failed.", "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public onChangeLicense(event: any): void {
    this.file = event.target.files[0];
    this.drivingLicenceLoading = true;

    this.services.uploadImage(this.file).subscribe((response: any) => {
      if (response.status === 201) {
        this.drivingLicenceLoading = false;

        var imgLicenceType = this.file.type.split("/");
        if (
          imgLicenceType[1] === "pdf" ||
          imgLicenceType[1] === ".jpg" ||
          imgLicenceType[1] === "png" ||
          imgLicenceType[1] === "jpeg"
        ) {
          this.documentForm.controls["driving_license"].setValue(
            response.body.image_link
          );
          this.licenseImageName = this.file.name;
          this.file = null;
          this.snackBar.open("File Added Successfully", "Success", {
            duration: 5000,
          });
        } else {
          this.snackBar.open(
            "Please upload only JPG or PNG or PDF type file",
            "Fail",
            {
              duration: 5000,
            }
          );
        }
      }
    });
  }

  public onChangeInsurance(event: any): void {
    this.file = event.target.files[0];
    this.insuranceLoading = true;

    this.services.uploadImage(this.file).subscribe((response: any) => {
      if (response.status === 201) {
        this.insuranceLoading = false;
        var imgType = this.file.type.split("/");
        if (
          imgType[1] === "pdf" ||
          imgType[1] === ".jpg" ||
          imgType[1] === "png" ||
          imgType[1] === "jpeg"
        ) {
          this.documentForm.controls["insurance"].setValue(
            response.body.image_link
          );
          this.insuranceImageName = this.file.name;
          this.file = null;
          this.snackBar.open("File Added Successfully", "Success", {
            duration: 5000,
          });
        } else {
          this.snackBar.open(
            "Please upload only JPG or PNG or PDF type file",
            "Fail",
            {
              duration: 5000,
            }
          );
        }
      }
    });
  }

  public formatFormDate(date: Date) {
    return formatDate(date, "yyyy-MM-dd", "en");
  }

  public isFieldRestricted(fieldName: string): boolean {
    return this.isDlVerified && !!this.autoPopulatedFields[fieldName];
  }

  public resetDlVerification(): void {
    this.isDlVerified = false;
    this.dlVerificationData = null;
    this.hasTransportAuthorization = false;
    this.autoPopulatedFields = {};
    if (this.profileForm?.controls['gender']) {
      this.profileForm.controls['gender'].enable();
    }
  }

  private parseDateToYmd(val: any): string {
    if (!val) return "";
    if (val instanceof Date && !isNaN(val.getTime())) {
      return formatDate(val, "yyyy-MM-dd", "en");
    }
    if (typeof val === "string") {
      const s = val.trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        return s;
      }
      const dmy = s.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/);
      if (dmy) {
        const day = dmy[1].padStart(2, "0");
        const month = dmy[2].padStart(2, "0");
        const year = dmy[3];
        return `${year}-${month}-${day}`;
      }
      const d = new Date(s);
      if (!isNaN(d.getTime())) {
        return formatDate(d, "yyyy-MM-dd", "en");
      }
    }
    return "";
  }

  public onDlNumberChange(): void {
    if (this.isDlVerified) {
      this.resetDlVerification();
    }
  }

  private normalizeDlNumber(dl: string): string {
    if (!dl) return "";
    let clean = dl.trim().toUpperCase();
    if (clean.includes(" ") || clean.includes("-")) {
      return clean;
    }
    // Match standard Indian format: 2 state letters, 2 RTO digits, 4-digit year, 7 digits (e.g. GJ0420120005008)
    const match = clean.match(/^([A-Z]{2}[0-9]{2})((?:19|20)[0-9]{2})([0-9]{7})$/);
    if (match) {
      return `${match[1]} ${match[2]}${match[3]}`;
    }
    return clean;
  }

  public verifyDrivingLicense(): void {
    const rawDl = this.profileForm.value.driving_license_number;
    const dobVal = this.profileForm.value.dob;

    if (!rawDl) {
      this.snackBar.open("Please enter Driving License Number to verify", "OK", {
        duration: 4000,
      });
      this.profileForm.controls["driving_license_number"].markAsTouched();
      return;
    }

    if (!dobVal) {
      this.snackBar.open("Please select Date of Birth (required by Sarathi for DL verification)", "OK", {
        duration: 4000,
      });
      this.profileForm.controls["dob"].markAsTouched();
      return;
    }

    const formattedDl = this.normalizeDlNumber(rawDl);
    const formattedDob = this.parseDateToYmd(dobVal);
    if (!formattedDob) {
      this.snackBar.open("Invalid Date of Birth format.", "Fail", { duration: 4000 });
      return;
    }

    this.isDlVerifying = true;
    this.services.verifyDrivingLicense(formattedDl, formattedDob, this.token).subscribe({
      next: (response: any) => {
        this.isDlVerifying = false;
        let resData = response.body?.data || response.body;
        // Unpack nested .data wrappers if present
        while (resData?.data && typeof resData.data === "object" && !resData.response) {
          resData = resData.data;
        }

        // Check for error response or format issues
        if (resData?.error === "true" || resData?.code === "400") {
          this.snackBar.open(resData.message || "Invalid DL or DOB format.", "Fail", {
            duration: 5000,
          });
          this.isDlVerified = false;
          return;
        }

        // Extract the inner response object
        const firstResp = Array.isArray(resData?.response) ? resData.response[0] : resData?.response;
        const innerResp = firstResp?.response || firstResp;

        if (!innerResp) {
          this.snackBar.open("No details available in National Register for this DL.", "Fail", {
            duration: 5000,
          });
          this.isDlVerified = false;
          return;
        }

        // Check for error inside response
        if (innerResp.errorcd === -1 || innerResp.erormsg) {
          this.snackBar.open(innerResp.erormsg || "No details available for this DL.", "Fail", {
            duration: 5000,
          });
          this.isDlVerified = false;
          return;
        }

        let dlNumber = "";
        let name = "";
        let gender = "";
        let status = "Active";
        let rto = "";
        let issueDate = "";
        let expiryDateStr = "";
        let classOfVehicle = "";
        let isTransport = false;
        let photoBase64 = "";
        let addressLine = "";

        // Format B: Nested dldetobj structure
        if (innerResp.dldetobj && Array.isArray(innerResp.dldetobj) && innerResp.dldetobj.length > 0) {
          const dldet = innerResp.dldetobj[0];
          if (dldet.errorcd === -1 || dldet.erormsg) {
            this.snackBar.open(dldet.erormsg || "No details available.", "Fail", { duration: 5000 });
            this.isDlVerified = false;
            return;
          }
          const bio = dldet.bioObj || {};
          const dlobj = dldet.dlobj || {};
          const dlcovs = dldet.dlcovs || [];

          dlNumber = dlobj.dlLicno || formattedDl;
          name = bio.bioFullName || `${bio.bioFirstName || ""} ${bio.bioLastName || ""}`.trim();
          gender = bio.bioGenderDesc || (bio.bioGender === "2" ? "Female" : "Male");
          status = dlobj.dlStatus || "Active";
          rto = dlobj.omRtoFullname || dlobj.stateName || "National Register";
          issueDate = dlobj.dlIssuedt || "";
          expiryDateStr = dlobj.dlTrValdtoDt || dlobj.dlNtValdtoDt || "";
          classOfVehicle = dlcovs.map((c: any) => c.covdesc || c.covabbrv).filter(Boolean).join(", ");
          isTransport = dlcovs.some(
            (c: any) =>
              (c.covabbrv && c.covabbrv.trim().toUpperCase() === "TRANS") || c.vecatg === "TR"
          );
          photoBase64 = dldet.bioImgObj?.biPhoto || "";
          addressLine = bio.bioPermAdd1 ? bio.bioPermAdd1.replace(/\*/g, "").trim() : "";
        } else {
          // Format A: Flattened Sarathi response (directly returned by MasterIndia API)
          dlNumber = innerResp.drivingLicenseNumber || formattedDl;
          name = innerResp.licenseHolderName || "";
          gender = innerResp.gender ? innerResp.gender.trim() : "";
          status = innerResp.currentLicenseStatus || "Active";
          rto = innerResp.issuingAuthority || "National Register";
          issueDate = innerResp.dlIssueDate || "";
          expiryDateStr =
            innerResp.transportValidity && innerResp.transportValidity !== "NA"
              ? innerResp.transportValidity
              : innerResp.nonTransportValidity || "";
          classOfVehicle = innerResp.classOfVehicleDetails || innerResp.dlCategory || "";

          const lType = (innerResp.licenseType || "").toLowerCase();
          const covUpper = (classOfVehicle || "").toUpperCase();
          isTransport =
            (lType.includes("transport") && !lType.includes("non-transport")) ||
            covUpper.includes("TRANS") ||
            covUpper.includes("TRANSPORT") ||
            covUpper.includes("TR");

          photoBase64 = innerResp.photograph || "";
          addressLine = innerResp.permanentAddress || innerResp.presentAddress || "";
        }

        this.isDlVerified = true;
        this.hasTransportAuthorization = isTransport;
        this.autoPopulatedFields = {};
        this.autoPopulatedFields['driving_license_number'] = true;
        this.autoPopulatedFields['dob'] = true;

        this.dlVerificationData = {
          dlNumber: dlNumber.trim(),
          name: name,
          gender: gender,
          status: status,
          rto: rto,
          issueDate: issueDate,
          validity: expiryDateStr,
          classOfVehicle: classOfVehicle,
          isTransport: isTransport,
          dlobj: {
            omRtoFullname: rto,
            dlStatus: status,
            dlTrValdtoDt: expiryDateStr,
          },
        };

        // 1. Auto-fill Driver Name (only if unmasked)
        if (name && !/^[\*\s]+$/.test(name)) {
          this.profileForm.patchValue({ username: name.trim() });
          this.contactForm.patchValue({ name: name.trim() });
          this.autoPopulatedFields['username'] = true;
          this.autoPopulatedFields['contact_name'] = true;
        }

        // 2. Auto-fill Gender
        if (gender) {
          const g = gender.toLowerCase().trim();
          if (g.includes("female")) {
            this.profileForm.patchValue({ gender: "female" });
            this.autoPopulatedFields['gender'] = true;
            this.profileForm.controls['gender'].disable();
          } else if (g.includes("male")) {
            this.profileForm.patchValue({ gender: "male" });
            this.autoPopulatedFields['gender'] = true;
            this.profileForm.controls['gender'].disable();
          } else if (g.includes("other")) {
            this.profileForm.patchValue({ gender: "others" });
            this.autoPopulatedFields['gender'] = true;
            this.profileForm.controls['gender'].disable();
          }
        }

        // 3. Auto-fill License Expiry Date
        if (expiryDateStr && expiryDateStr !== "NA" && !expiryDateStr.includes("*")) {
          const expDate = new Date(expiryDateStr);
          if (!isNaN(expDate.getTime())) {
            this.profileForm.patchValue({ license_expiry_date: expDate });
            this.documentForm.patchValue({ driving_license_expiry: expDate });
            this.invalidlicenseDate = false;
            this.invalidDocLicense = false;
            this.autoPopulatedFields['driving_license_expiry'] = true;
            this.autoPopulatedFields['license_expiry_date'] = true;
          }
        }

        // 4. Update Driving License Number with official formatted string
        if (dlNumber) {
          this.profileForm.patchValue({ driving_license_number: dlNumber.trim() });
        }

        // 5. Auto-fill Address if unmasked
        if (addressLine && !/^[\*\s]+$/.test(addressLine)) {
          this.contactForm.patchValue({ address_line: addressLine.trim() });
          this.autoPopulatedFields['address_line'] = true;
        }

        // 6. Auto-load Driver Photo (Base64 JPEG) if unmasked
        if (photoBase64 && !photoBase64.includes("*") && photoBase64.length > 50) {
          this.uploadBase64Photo(photoBase64, name || this.profileForm.value.username);
        }

        this.snackBar.open("Driving License verified successfully via Sarathi!", "Success", {
          duration: 5000,
        });
      },
      error: (error: any) => {
        this.isDlVerifying = false;
        this.isDlVerified = false;
        if (["jwt malformed", "jwt expired", "invalid signature"].includes(error.error?.message)) {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
          this.matdialogre.close();
        }
        const errorMsg =
          error.error?.error?.message ||
          error.error?.message ||
          error.message ||
          "Failed to verify Driving License.";
        this.snackBar.open(errorMsg, "Fail", { duration: 5000 });
      },
    });
  }

  private uploadBase64Photo(base64Data: string, driverName: string): void {
    try {
      const dataUri = `data:image/jpeg;base64,${base64Data}`;
      this.profileForm.controls["profile_image"].setValue(dataUri);

      // Convert Base64 to Blob & File to upload through services.uploadImage
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/jpeg" });
      const cleanName = (driverName || "driver").replace(/[^a-zA-Z0-9]/g, "_");
      const file = new File([blob], `${cleanName}_dl_photo.jpg`, { type: "image/jpeg" });

      this.imgLoading = true;
      this.services.uploadImage(file).subscribe({
        next: (response: any) => {
          this.imgLoading = false;
          if (response.status === 201 && response.body?.image_link) {
            this.profileForm.controls["profile_image"].setValue(response.body.image_link);
          }
        },
        error: () => {
          this.imgLoading = false;
          // Retain dataUri preview if upload fails
        },
      });
    } catch (e) {
      this.profileForm.controls["profile_image"].setValue(`data:image/jpeg;base64,${base64Data}`);
    }
  }

  public onSave() {
    const rawProfile = this.profileForm.getRawValue();
    const rawContact = this.contactForm.getRawValue();
    const rawDocument = this.documentForm.getRawValue();

    // 1. Validate Mobile Verification
    if (this.mobileVerified !== 1) {
      this.snackBar.open("Please verify Driver's Mobile number", "Fail", {
        duration: 5000,
      });
      return;
    }
    // 2. Driver Name Required
    const driverName = rawProfile.username;
    if (!driverName) {
      this.snackBar.open("Please enter Driver Name", "Fail", {
        duration: 5000,
      });
      return;
    }
    // 3. Gender Required
    const gender = rawProfile.gender;
    if (!gender) {
      this.snackBar.open("Please select Gender", "Fail", {
        duration: 5000,
      });
      return;
    }
    // 4. DOB Required
    const dob = rawProfile.dob;
    if (!dob) {
      this.snackBar.open("Please enter Date of Birth", "Fail", {
        duration: 5000,
      });
      return;
    }
    // 5. Driving License Number Required
    const dlNumber = rawProfile.driving_license_number;
    if (!dlNumber) {
      this.snackBar.open("Please enter Driving License Number", "Fail", {
        duration: 5000,
      });
      return;
    }
    // 6. Known Language Required
    const knownLang = rawProfile.known_lang;
    if (!knownLang || knownLang.length === 0) {
      this.snackBar.open("Please select at least one language", "Fail", {
        duration: 5000,
      });
      return;
    }
    // 7. Driving License Expiry Required
    const licenseExpiry = rawDocument.driving_license_expiry;
    if (!licenseExpiry) {
      this.snackBar.open("Please enter Driving License Expiry Date", "Fail", {
        duration: 5000,
      });
      return;
    }
    // 8. Driving License Image Required
    if (!this.licenseImageName) {
      this.snackBar.open("Please upload Driving License Image", "Fail", {
        duration: 5000,
      });
      return;
    }
    const driverData = {
      username: driverName,
      mobile: rawProfile.mobile,
      email: rawProfile.email,
      driving_license_number: dlNumber,
      truck_id: rawProfile.truck_id,
      known_lang: knownLang,
      license_expiry_date: licenseExpiry,
      emergency_contact: rawProfile.emergency_contact,
      profile_image: rawProfile.profile_image,
      gender: gender,
      dob: dob,
      dl_verified: !!this.isDlVerified,
      is_dl_verified: !!this.isDlVerified,
      contact_details: rawContact,
      documents: {
        ...rawDocument,
        dl_verified: !!this.isDlVerified,
        is_dl_verified: !!this.isDlVerified,
      },
    };
    this.id = sessionStorage.getItem("driverRegId");
    if (driverData && !driverData.license_expiry_date) {
      delete driverData.license_expiry_date;
    }
    if (driverData && !driverData.dob) {
      delete driverData.dob;
    }
    this.services.AddDriver(driverData, this.token, this.id).subscribe(
      (response: any) => {
        if ((response.status == 201 || response.status == 200) || response.body?.data) {
          this.matdialogre.close({ event: "Success" });
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (["jwt expired", "jwt malformed"].includes(error.error.message)) {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
          this.matdialogre.close();
        }
      }
    );
    this.loading = false;
  }

  public onEditSave() {
    const rawProfile = this.profileForm.getRawValue();
    const rawContact = this.contactForm.getRawValue();
    const rawDocument = this.documentForm.getRawValue();

    // 1. Driver Name Required
    const driverName = rawProfile.username;
    if (!driverName) {
      this.snackBar.open("Please enter Driver Name", "Fail", { duration: 5000 });
      return;
    }
    // 2. Gender Required
    const gender = rawProfile.gender;
    if (!gender) {
      this.snackBar.open("Please select Gender", "Fail", { duration: 5000 });
      return;
    }
    // 3. DOB Required
    const dob = rawProfile.dob;
    if (!dob) {
      this.snackBar.open("Please enter Date of Birth", "Fail", { duration: 5000 });
      return;
    }
    // 4. Driving License Number
    const dlNumber = rawProfile.driving_license_number;
    if (!dlNumber) {
      this.snackBar.open("Please enter Driving License Number", "Fail", { duration: 5000 });
      return;
    }
    // 5. Known Languages
    const knownLang = rawProfile.known_lang;
    if (!knownLang || knownLang.length === 0) {
      this.snackBar.open("Please select at least one language", "Fail", { duration: 5000 });
      return;
    }
    // 6. Driving License Expiry
    const licenseExpiry = rawDocument.driving_license_expiry;
    if (!licenseExpiry) {
      this.snackBar.open("Please enter Driving License Expiry Date", "Fail", { duration: 5000 });
      return;
    }
    // 7. Driving License Image
    if (!this.licenseImageName && !this.DrivingLicence) {
      this.snackBar.open("Please upload Driving License Image", "Fail", { duration: 5000 });
      return;
    }

    this.remarksArray.push(rawProfile.driver_remarks);

    const driverData: any = {
      username: driverName,
      mobile: rawProfile.mobile,
      email: rawProfile.email,
      driving_license_number: dlNumber,
      license_expiry_date: licenseExpiry,
      truck_id: rawProfile.truck_id,
      known_lang: knownLang,
      emergency_contact: rawProfile.emergency_contact,
      profile_image: rawProfile.profile_image,
      gender: gender,
      dob: dob,
      dl_verified: !!this.isDlVerified,
      is_dl_verified: !!this.isDlVerified,
      contact_details: rawContact,
      driver_status: rawProfile.driver_status,
      driver_remarks: this.remarksArray,
      documents: {
        ...rawDocument,
        dl_verified: !!this.isDlVerified,
        is_dl_verified: !!this.isDlVerified,
      },
    };
    // Clean optional fields
    if (!driverData.license_expiry_date) delete driverData.license_expiry_date;
    if (!driverData.dob) delete driverData.dob;
    this.loading = true;
    this.services.EditDriver(driverData, this.token, this.data._id).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === 200) {
          this.matdialogre.close({ event: "Success" });
          window.location.reload();
        }
      },
      (error) => {
        this.loading = false;
        if (["jwt malformed", "jwt expired"].includes(error.message)) {
          sessionStorage.clear();
          this.router.navigateByUrl("/");
        }
        this.snackBar.open(error.error.message, "Fail", { duration: 5000 });
      }
    );
  }

  reject() {
    this.reasons = true;
  }
  maintance() {
    this.profileForm.value.driver_remarks = "";
    this.reasons = false;
  }
  available() {
    this.reasons = false;
    this.profileForm.value.driver_remarks = "";
  }
  cancelInsuranceImage() {
    this.insuranceImageName = "";
    this.documentForm.controls["insurance"].setValue("");
  }

  cancelLicenseImage() {
    this.documentForm.controls["driving_license"].setValue("");
    this.licenseImageName = "";
  }

  close() {
    this.matdialogre.close({ event: "Success" });
  }

  sendEmail() {
    if (!this.profileForm.controls["email"].valid) {
      this.profileForm.controls["email"].markAsTouched();
      return;
    }
    const dataValue = {
      email: this.profileForm.value.email,
      displayText: "email",
      from: "truckowner",
    };
    let matDialogref = this.matDialog.open(OtpVerifyComponent, {
      width: "500px",
      data: {
        dataKey: dataValue,
      },
      autoFocus: false,
    });
    matDialogref.afterClosed().subscribe((res: any) => {
      if (res.event === "Success") {
        this.emailVerified = 1;
      }
    });
  }
  onDoneClick() {
    this.langSelect.close();
  }
  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
